import React from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import FASTable from "../../../../../components/Tables/FASTable";
import {
  PayAgingDtl,
  RecAgingDtlFun,
} from "../../../../../Redux/Slice/Fas/ReceivablePayble/ReceivablePaybleSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function AgingDetail({
  accountGroup,
  accountName,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { PayAgingDtldata } = useSelector(
    (state) => state.ReceivablePaybleSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "";

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }
  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

  const getRows = PayAgingDtldata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    VouDate: formatDateToDDMMYYYY(label.VouDate),
    AgingDays: label.AgingDays,
    DueDays: label.DueDays,
    InvoiceNum: label.InvoiceNum,
    OustandingAmount: formatIndianRupee(label.OustandingAmount),
    Status: label.Status,
  }));

  const getColumns = [
    // { Header: "Chart", key: "chartButton", width: 60 },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Invoice Number", key: "InvoiceNum", align: "right" },
    { label: "Vou Date", key: "VouDate", align: "center" },
    {
      label: "Oustanding Amount",
      key: "OustandingAmount",
      align: "right",
      format: "true",
    },
    { label: "Ageing Days", key: "AgingDays", align: "right" },
    { label: "Due Days", key: "DueDays", align: "right" },
    { label: "Status", key: "Status", align: "left" },
  ];

  if (PayAgingDtldata === "no" || PayAgingDtldata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            AGEING DETAIL
          </h2>
        </div>

        <FASTable columns={getColumns} data={getRows} />
      </div>
    </div>
  );
}
